import {BehaviorSubject, Observable} from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { tap, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { Enterprise } from '../models/enterprise-modal';
import { ErrorCode } from '../constants/error-code';
const routes = {
  filter: '/enterprises/filter',
  add: (tenantId: string) => `/enterprises/${tenantId}`,
  changeStatus: (id: string) => `/enterprises/change-status/${id}`,
  update: (id: string) => `/enterprises/update/${id}`,
  enterprise: (id: string) => `/enterprises/${id}`,
  enterpriseWithType: (id: string,type:string) => `/enterprises/${id}${type?`?type=${type}`:''}`,
  getPermissionHSM: (id: string) => `/enterprises/configs/${id}`,
  getEnterpriseResources: (id: string) => `/enterprises/resources/${id}`,
  getAllEnterpriseToBranch: `/enterprises/get-all-enterprise-to-branch`,
  upadteEnterpriseToBranch: '/enterprises/update-enterprise-to-branch',
  updatePermissionHSM: '/enterprises/update-configs',
  serviceTypeEssential: '/service-types/get-service-type-essential',
  getEnterpriseCheckResources: '/enterprises/check-resources-contract'
};

@Injectable({
  providedIn: 'root'
})
export class AsEnterpriseService {
  public enabelHsmAndBranch = new BehaviorSubject<any>({
    isEnableHsm : false,
    isEnableManageBranch : false
  });

  constructor(private apiService: ApiService, private httpClient: HttpClient) { }

  getAllEnterprise(filter: any) {
    return this.apiService.post(routes.filter, filter).pipe(
      map(rs => {
        return rs;
      })
    );
  }

  addEnterprise(value: any, noCallBack: any, errCallback: any) {
    this.apiService.addUrlToHandlingErrorRestApis(routes.add(localStorage.getItem('tenantId')));
    return this.apiService.post(routes.add(localStorage.getItem('tenantId')), value).pipe(map(res => {
      if (errCallback && !res.success) {
        errCallback(res);
      } else if (res && (res.code === ErrorCode.CertificateCodeDuplicate || res.code === ErrorCode.TaxCodeDuplicate)) {
        noCallBack(res.code);
      }
      return res;
    }));
  }

  updateEnterprise(id: string, value: any, callBack: any, noCallBack: any, errCallback: any) {
    return this.apiService.putAndCheckVersion(
      routes.update(id),
      value,
      callBack,
      noCallBack,
      errCallback
    );
  }

  changeStatusEnterprise(id: string) {
    return this.apiService.get(routes.changeStatus(id));
  }

  getPermissionHSM(id: string) {
    return this.apiService.get(routes.getPermissionHSM(id)).pipe(
      map(res => {
        this.enabelHsmAndBranch.next({
          isEnableHsm : res.data.enableHsm,
          isEnableManageBranch : res.data.enableManageBranch
        });
        return res;
      })
    );
  }

  updatePermissionHSM(obj) {
    return this.apiService.post(routes.updatePermissionHSM, obj).pipe(
      map(res => {
        return res;
      })
    )
  }

  getEnterpriseByID(id: string) {
    return this.apiService.get(routes.enterprise(id)).pipe(
      map(data => data
      )
    );
  }

  getEnterpriseResourcesByID(id: string) {
    return this.apiService.get(routes.getEnterpriseResources(id)).pipe(
      map(res => {
        return res;
      })
    )
  }

  getEnterpriseCheckResources() {
    return this.apiService.get(routes.getEnterpriseCheckResources).pipe(
      map(res => {
        return res;
      })
    )
  }

  // silent: pre-check truoc khi save tai add-document, khong block UI toan trang
  getEnterpriseCheckResourcesSilently() {
    return this.apiService.getSilently(routes.getEnterpriseCheckResources).pipe(
      map(res => {
        return res;
      })
    )
  }

  getEnterpriseByIDandType(id: string,type:string) {
    return this.apiService.get(routes.enterpriseWithType(id,type)).pipe(
      map(data => data
      )
    );
  }

  getAllEnterpriseToBranch(obj: any) {
    return this.apiService.post(routes.getAllEnterpriseToBranch, obj).pipe(
      map(res => {
        return res;
      })
    )
  }

  upadteEnterpriseToBranch(obj: any) {
    return this.apiService.post(routes.upadteEnterpriseToBranch, obj).pipe(
      map(res => {
        return res;
      })
    )
  }

  getAllServiceTypeEssential(body: Object) {
    return this.apiService.post(routes.serviceTypeEssential, body).pipe(
      map(data => {
        return data;
      })
    )
  }

}
